import './App.css';
import Footer from './conponents/Footer/Footer';
import { Hero } from './conponents/Hero/Hero';
import Join from './conponents/Join/Join';
import Plans from './conponents/Plans/Plans';
import Programs from './conponents/Programs/Programs';
import Reasons from './conponents/Reasons/Reasons';
import Testimonials from './conponents/Testimonials/Testimonials';


function App() {
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
